import { Maybe, ReportSection } from 'gqlTypes'

export function getCurrentSection(
  sections: ReportSection[],
  sectionId: string
) {
  return sections.find((section) => section.id === sectionId)
}

export function getParentSection(
  sections: ReportSection[],
  sectionId: Maybe<string> | undefined
) {
  return sectionId
    ? sections.find((section) => section.id === sectionId)
    : undefined
}
